@if (isLoading()) {
  <mat-progress-bar class="fixed top-0 left-0 z-50 w-full" mode="indeterminate"></mat-progress-bar>
}

<div class="flex flex-col gap-6 w-[400px] p-8 gap-y-6">
  <div class="flex justify-between">
    <span class="font-medium text-base text-color-normal">
      @if (isUpdatingAssignee()) {
        {{ translationPrefix + '.TITLE_UPDATE' | translate }}
      }
      @if (!isUpdatingAssignee()) {
        {{ translationPrefix + '.TITLE' | translate }}
      }
    </span>
    <mat-icon
      [ngClass]="{
        'cursor-pointer hover:opacity-80': !isLoading(),
        'opacity-40': isLoading(),
      }"
      (click)="isLoading() ? null : closeModal()"
      class="flex justify-center items-center text-lg text-color-secondary"
      >close</mat-icon
    >
  </div>

  <span class="text-sm text-color-secondary">{{ translationPrefix + '.DESCRIPTION' | translate }}</span>
  <app-fc-select-multiple-paged
    [service]="usersService"
    [fixDropdownDirection]="'down'"
    [showImage]="true"
    [control]="assigneeForm.get('assignees')"
    [ignoredIds]="ignoredIds"
    [placeholder]="translationPrefix + '.LABEL' | translate"
  >
  </app-fc-select-multiple-paged>
  <div class="flex gap-3">
    <button
      (click)="updateAssignee()"
      [disabled]="shouldDisableButton() || isLoading()"
      [ngClass]="{
        'cursor-pointer hover:opacity-80': !shouldDisableButton() && !isLoading(),
        'opacity-40': shouldDisableButton() || isLoading(),
      }"
      class="grow py-4 focus:outline-none rounded bg-color-primary text-white border-none font-medium text-sm font-['Roboto'] shadow-[0_0px_4px_0px_rgba(0,0,0,0.1)]"
      type="button"
    >
      @if (isUpdatingAssignee()) {
        {{ translationPrefix + '.BUTTONS.UPDATE' | translate }}
      }
      @if (!isUpdatingAssignee()) {
        {{ translationPrefix + '.BUTTONS.SAVE' | translate }}
      }
    </button>
  </div>
</div>
